export default __webpack_public_path__ + "static/media/contact.003435a9.svg";